export const gotoOnBoard = (userId, workspaceId?) => {
  return `/onboard/${[userId, workspaceId].filter(Boolean).join('/')}`
}
